/**
 * Returns a new array without duplicate items (using equality)
 */
export function deduplicate<T>(array: T[]) {
  return [...new Set(array)];
}
